import React from "react";
import "../styles/footer.css";

export const Footer = () => {
  return (
    <footer className="footer">

      <div className="footer__container">

        {/* INFO RESTAURANTE */}
        <div className="footer__col">
          <h3 className="footer__title">Perfisoft</h3>

          <p className="footer__text">
           Somos una equipo multidiciplinario que construye software 
            fácil de usar.
          </p>
        </div>


        {/* HORARIO */}
        <div className="footer__col">
          <h3 className="footer__title">Horario</h3>

          <p className="footer__text">
            Lunes - Viernes: 08:00 AM - 06:00 PM
          </p>

          <p className="footer__text">
            Sábados: 08:00 AM - 1:00 PM
          </p>

        </div>


        {/* CONTACTO */}
        <div className="footer__col">
          <h3 className="footer__title">Contacto</h3>

          <p className="footer__text">
            Av. Loreto 123, Piura
          </p>

          <p className="footer__text">
            +51 969 849 187
          </p>

          <p className="footer__text">
            sandoya01@gmail.com
          </p>
        </div>

      </div>


      {/* COPYRIGHT */}
      <div className="footer__bottom">
        © 2026 sandoya. Todos los derechos reservados.
      </div>

    </footer>
  );
};